/**
 * The fee a client pays on top of the fare, when the office has "Client pays
 * the fee" on (D3; InGo ADR 0047): a percentage of the fare in basis points,
 * half up to a whole cent, plus a fixed amount in cents. Integers throughout.
 *
 * The twin of the server's `Modules\Payments\Checkout\Fees::clientPays`, and
 * tested on its cases (`FeesTest.php`), so the total shown is the total
 * charged. The server's figure is still the one charged and shown after.
 *
 * @param {number} fareMinor
 * @param {{client_pays: boolean, percent_bp: number, fixed_minor: number} | null | undefined} fee
 * @returns {number}
 */
export function clientPaysFee(fareMinor, fee) {
  if (!fee || fee.client_pays !== true) return 0;
  const bp = Math.max(0, Math.trunc(Number(fee.percent_bp) || 0));
  const fixed = Math.max(0, Math.trunc(Number(fee.fixed_minor) || 0));
  // fare × bp / 10 000, half up, in integers: (2 × fare × bp + 10 000) ÷ 20 000.
  const percent = Math.floor((2 * Math.trunc(fareMinor) * bp + 10000) / 20000);

  return percent + fixed;
}
